/* eslint-disable no-bitwise */
import { useEffect, useState } from 'react';
import { api } from 'Helpers/ApiCall';
import Cookies from 'universal-cookie';
import useQuery from 'Helpers/hooks/useQuery';
import { GetInsightURL, GetAPIBaseURL, GetToken } from 'Helpers';
import { API_REDIRECT } from 'Config/api';
import PageAccessDenied from 'Screens/PageAccessDenied';

const Index = () => {
  const query = useQuery();
  const cookies = new Cookies();
  const [isAccesDenided, setAccessDenied] = useState(false);

  useEffect(() => {
    if (!query.get('v')) {
      setAccessDenied(true);
      return;
    }

    const sendParams = async () => {
      const params = query.get('v').split('.') || [];

      const cid = params[0];
      const uid = params[1];
      const enc = params[2];

      try {
        const {
          data: { data },
          status,
        } = await api(
          'GET',
          GetAPIBaseURL(),
          API_REDIRECT,
          null,
          '',
          {
            cid,
            uid,
            enc,
          },
          {
            'Content-Type': 'application/json',
            Authorization: GetToken(),
          }
        );

        if (status === 200) {
          cookies.set('isEmail', true);
          window.location.href = `${GetInsightURL()}?cid=${data}`;
        }
      } catch (error) {
        if (error) {
          setAccessDenied(true);
        }
      }
    };
    sendParams();
  }, []);

  return <>{isAccesDenided && <PageAccessDenied />}</>;
};

export default Index;
